/**
 * «Сайт и контент» без блоков вопросов (#848): пояснение без выдуманных чисел
 * (решение владельца 28.09) — флаг закрыт или шлюз сервера закрыт.
 */
import { useTranslation } from 'react-i18next';
import { FileQuestion, Lock } from 'lucide-react';
import { CUSTOMER_QUESTIONS_FLAG_KEY, findTierFeatureGate } from '@aica/core';
import { TIER_DISPLAY } from '@aica/stripe/tier-config';
import { DashboardPanel } from '@/components/dashboard/dashboard-panel';

/**
 * `withThemes`: the themes block (its own flag) is drawn under the notice, so
 * the text must not say the tab has nothing to show or that themes are not
 * extracted.
 */
export function VoiceSitePending({ withThemes = false }: { withThemes?: boolean }) {
  const { t } = useTranslation('dashboard');
  return (
    <div className="space-y-4">
      <p className="text-sm text-fg-muted">{t('voicePage.audienceHint.site')}</p>
      <DashboardPanel title={t('voicePage.site.title')}>
        <div className="flex flex-col items-center gap-2 py-6 text-center">
          <FileQuestion className="h-5 w-5 text-fg-muted" />
          <p className="max-w-prose text-sm text-fg-muted">
            {t(
              withThemes ? 'voicePage.site.pendingWithThemes' : 'voicePage.site.pending'
            )}
          </p>
          <p className="max-w-prose text-xs text-fg-subtle">
            {t('voicePage.site.faq.pending')}
          </p>
        </div>
      </DashboardPanel>
    </div>
  );
}

/**
 * The organization's plan is below the blocks' own floor (the server's
 * verdict `tier_not_eligible`): a plan matter, not a switch — the plan they
 * come with and the section's own way to the plans, never «contact support».
 */
export function VoiceQuestionsUpgrade({ upgradeHref }: { upgradeHref?: string }) {
  const { t } = useTranslation('dashboard');
  const minTier = findTierFeatureGate(CUSTOMER_QUESTIONS_FLAG_KEY)?.minTier ?? 'pro';
  return (
    <div className="space-y-4">
      <p className="text-sm text-fg-muted">{t('voicePage.audienceHint.site')}</p>
      <DashboardPanel title={t('voicePage.site.title')}>
        <div className="flex flex-col items-center gap-2 py-6 text-center">
          <Lock className="h-5 w-5 text-fg-muted" />
          <p className="max-w-prose text-sm text-fg-muted">
            {t('voicePage.site.upgrade', { plan: TIER_DISPLAY[minTier].name })}
          </p>
          {upgradeHref ? (
            <a
              href={upgradeHref}
              className="text-sm font-medium text-primary transition-colors hover:underline focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring"
            >
              {t('voicePage.locked.tier_not_eligible.cta')}
            </a>
          ) : (
            <p className="max-w-prose text-sm text-fg-muted">
              {t('voicePage.locked.tier_not_eligible.askOwner')}
            </p>
          )}
        </div>
      </DashboardPanel>
    </div>
  );
}
